'use client'
import { envs } from '@config/envs'
import { AuthHandler } from '@core/auth/utils/auth-handler'
import axios, { AxiosInstance } from 'axios'

let axiosInstance: AxiosInstance | null = null

export function getAxiosInstance() {
  const accessToken = AuthHandler.getTokens().accessToken

  if (axiosInstance) {
    return axiosInstance
  }

  axiosInstance = axios.create({
    baseURL: envs.cerberusApiUrl,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  axiosInstance.interceptors.response.use(
    (response) => response,
    async function (error) {
      const config = error.config

      if (error.response?.status === 401) {
        const accessToken = await AuthHandler.refreshTokens()
        config.headers = {
          ...config.headers,
          authorization: `Bearer ${accessToken}`,
        }
        return axios(error.config)
      }
      return Promise.reject(error)
    }
  )

  return axiosInstance
}
